export { default } from './GtagContainer';



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/gtag/index.js